/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IAPINCOMEOPTION = {
    Amount: 'A',
    Percent: 'P',
    AmountPercent: 'B',
    Units: 'U'
} as const;
export type IAPINCOMEOPTION = typeof IAPINCOMEOPTION[keyof typeof IAPINCOMEOPTION];


export function IAPINCOMEOPTIONFromJSON(json: any): IAPINCOMEOPTION {
    return IAPINCOMEOPTIONFromJSONTyped(json, false);
}

export function IAPINCOMEOPTIONFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAPINCOMEOPTION {
    return json as IAPINCOMEOPTION;
}

export function IAPINCOMEOPTIONToJSON(value?: IAPINCOMEOPTION | null): any {
    return value as any;
}

